var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VideoProgressBar",on:{"click":_vm.handleClick}},_vm._l((_vm.parts),function(part,i){return _c('div',{key:i,staticClass:"Mark",style:({ left: (((part.end / _vm.duration) * 100) + "%") })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }